import React, {PropTypes} from 'react';
import Geosuggest from 'react-geosuggest';
import './location_auto_search.less'

export default class LocationAutoSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active : false
    }
  }
  onSuggestSelect = (suggest) =>{
    this.setState({
      active : false
    })
    let address = this.getFullAddress(suggest)
    this.props.changeHandler(this.props.for , address)
  }
  getFullAddress = (suggest) => {
    let addressComponents = suggest.gmaps.address_components;
    let cityName , landMark ,country,countryCode,postalCode=null;
    for(let i=0;i< addressComponents.length;i++)
    {
        let types = addressComponents[i].types ;
        for(let j = 0; j< types.length ; j++)
        {
          if(types[j] == "locality")
          {
            cityName = addressComponents[i].long_name ;
            break;
          }
          if(types[j] == "premise")
          {
            landMark = addressComponents[i].long_name
              break;
          }
          if(types[j] == "country"){
            country = addressComponents[i].long_name
            countryCode =  addressComponents[i].short_name
              break;
          }
          if(types[j] == "postal_code"){
            postalCode = addressComponents[i].long_name
            break;
          }
        }
    }
    let address ;
    if(postalCode)
      suggest.label = suggest.label +" "+postalCode
    address = {
      landMark,
      cityName,
      country,
      countryCode,
      location: suggest.location,
      label:suggest.label
    }
    return address;
  }
  changeHandler = (e) =>{
    this.setState({
      active : true
    })
    this.props.changeHandler(this.props.for , null)
  }
  onFocus = () =>{
    this.setState({
      active : true
    })
  }
  onBlur = () =>{
    this.setState({
      active : false
    })
  }
  render() {
    const self = this;
    return (
      <div className ="location-auto-seach-wrap">
        <div className ="title">
          {this.props.title}
        </div>
        <div className ="input-component">
          <Geosuggest
             onSuggestSelect={this.onSuggestSelect}
             inputClassName ="input"
             suggestsClassName ="suggestsClassName"
             suggestItemClassName ={self.state.active ? "item" : "hide"}
             suggestItemActiveClassName = "active"
             onFocus ={this.onFocus}
             onBlur = {this.onBlur}
             placeholder = {this.props.placeholder}
             initialValue = {this.props.value || ""}
             onChange = {this.changeHandler}
             disabled ={this.props.disabled}
          />
        </div>
      </div>
    )
  }
}

LocationAutoSearch.propTypes = {
  title : React.PropTypes.string.isRequired,          //title for the input component
  value : React.PropTypes.any,                        //initial value for the input component
  placeholder : React.PropTypes.string.isRequired,    //placeholder for the component
  for : React.PropTypes.any.isRequired,                //unique id for the component e.g., state name in parent component
  changeHandler : React.PropTypes.func.isRequired,     //returns for and new value for the component
  disabled: React.PropTypes.bool
};



// WEBPACK FOOTER //
// app/components/location_auto_search/location_auto_search.jsx